export const FOCUS_EAGRID_EVENT = 'focus_eag_grid_event';

export type FocusGridPart = 'smartSearch' | 'row';

export type FocusEagridCustomEvent = {
  gridCode: string;
  part: FocusGridPart;
};

export const focusGridPart = (gridCode: string, part: FocusGridPart) => {
  const event = new CustomEvent(FOCUS_EAGRID_EVENT, {detail: {gridCode, part}});

  window.dispatchEvent(event);
};
